(() => {
  const RATIO = 16 / 9; // change if your Vimeo isn’t 16:9

  function sizeHeroIframes() {
    document.querySelectorAll('.herobanner-home__video-embed').forEach((wrap) => {
      const iframe = wrap.querySelector('iframe');
      if (!iframe) return;

      const cw = wrap.clientWidth;
      const ch = wrap.clientHeight;
      if (!cw || !ch) return;

      // Cover logic: fill container while preserving aspect ratio
      let w, h;
      if (cw / ch > RATIO) {
        w = cw;
        h = cw / RATIO;
      } else {
        h = ch;
        w = ch * RATIO;
      }

      iframe.style.width = `${Math.ceil(w)}px`;
      iframe.style.height = `${Math.ceil(h)}px`;
    });
  }

  window.addEventListener('resize', sizeHeroIframes, { passive: true });
  window.addEventListener('orientationchange', sizeHeroIframes);
  document.addEventListener('DOMContentLoaded', sizeHeroIframes);

  // If your iframe is injected late, also run shortly after load.
  window.addEventListener('load', sizeHeroIframes);
})();
